// resources
import studentEndpoints from 'api/resources/student';

// utils
import { isRoleType } from 'lib/helpers';

// constants
import { ROLES_OBJECT } from 'constants/onBoarding';

const { deleteBaby, moveBabiesAsTeacher, moveBabies } = studentEndpoints;

const configQuery = {
  retry: false,
  enabled: false,
  refetchOnMount: true,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
};

export const studentQuery = {
  deleteStudentQuery: {
    key: 'delete-student',
    resource: deleteBaby,
    config: configQuery,
  },
};

export const moveStudentsQuery = {
  key: 'move-students',
  resource: ({ body, currentCenterId }) => {
    if (!isRoleType([ROLES_OBJECT.TEACHER.value])) {
      return moveBabies({ body, currentCenterId });
    }
    return moveBabiesAsTeacher(body);
  },
  config: configQuery,
};
